import React from 'react';

const AdminListViewControls = ({
  viewMode,
  onViewModeChange,
  selectedCount = 0,
  onSelectAll,
  onClearSelection,
  allSelected = false,
  someSelected = false,
  totalCount = 0,
  /** Full result set size when using infinite scroll; omit if unknown. */
  resultTotal = null,
  showSelection = true,
  selectionHint = null
}) => {
  const selectAllLabel = (() => {
    if (!totalCount) return 'Select all';
    if (resultTotal != null && resultTotal > totalCount) {
      return `Select all loaded (${totalCount} of ${resultTotal})`;
    }
    return `Select all loaded (${totalCount})`;
  })();

  return (
    <div className="admin-list-view-controls">
      {showSelection ? (
        <div className="admin-list-view-selection">
          {totalCount > 0 && (
            <label className="admin-list-select-all">
              <input
                type="checkbox"
                checked={allSelected}
                ref={(el) => {
                  if (el) el.indeterminate = someSelected && !allSelected;
                }}
                onChange={() => (allSelected ? onClearSelection() : onSelectAll())}
                aria-label={selectAllLabel}
              />
              <span>{selectAllLabel}</span>
            </label>
          )}
          {selectedCount > 0 && (
            <>
              <span className="admin-list-selection-count">{selectedCount} selected</span>
              <button type="button" className="btn btn-sm btn-secondary" onClick={onClearSelection}>
                Clear selection
              </button>
            </>
          )}
          {selectionHint && selectedCount === 0 && totalCount > 0 && (
            <span className="admin-list-selection-hint">{selectionHint}</span>
          )}
        </div>
      ) : (
        <div />
      )}
      <div className="admin-view-toggle" role="group" aria-label="List view mode">
        <button
          type="button"
          className={`btn btn-sm btn-secondary${viewMode === 'grid' ? ' is-active' : ''}`}
          onClick={() => onViewModeChange('grid')}
          aria-pressed={viewMode === 'grid'}
        >
          Grid
        </button>
        <button
          type="button"
          className={`btn btn-sm btn-secondary${viewMode === 'table' ? ' is-active' : ''}`}
          onClick={() => onViewModeChange('table')}
          aria-pressed={viewMode === 'table'}
        >
          Table
        </button>
      </div>
    </div>
  );
};

export default AdminListViewControls;
